

exports.__esModule = true;

var _index = require('squid/index');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Route.extend('$xoNbrDEPageRoute', {

    path: 'negativeBalanceRecovery',
    directive: _directive2['default'],
    // titleContent: 'nbr.title',

    // trackingData: {
    //     fptiState: 'econsent',
    //     templateName: 'eConsent.dust',
    //     pageGoal: 'eConsent',
    //     buzname: {
    //         'fullpage': {
    //             'pagename': '%::fullpage-econsent',
    //             'pagename2': '%::fullpage-econsent:member:hermes:',
    //             'version': 'member:%:'
    //         }
    //         // More page qualifiers come here...
    //     }
    // },

    children: []
});


_index.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-nbr/route.js
// module id = ./pages/xo-nbr/route.js
// module chunks = 1